export const TABLE_PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 150];

export const DEFAULT_TABLE_PAGE_SIZE = 100;
